<template>
    <div class="footer-wap">
        <i class="iconfont icon-a-SPRLOGO"></i>

        <div class="phone" @click="open">咨询热线：023-67665596 或 18580875987</div>
        <span>邮箱：service@mhkjcq.com</span>
        <span>地址：重庆市巴南区木洞镇天益路9号重庆国际生物城E3栋2单元</span>
        <div class="footer-botton">
            <div>
            <p>重庆市斯普瑞科技有限公司 版权所有</p>
<!--            <p>备案序号：渝ICP备060540049号-1</p>-->
                <div class="code"><a href="https://beian.miit.gov.cn" target="_blank" style="cursor: pointer;color: #FFFFFF" >备案序号：渝ICP备060540049号-1</a></div>
            </div>
        </div>

        <!--点击咨询热线弹窗-->
        <div class="model-box22" v-show="modelShow">
            <div class="model-bg" @click="modelShow=false"></div>
            <div class="model-content">
                请选择咨询热线：<br/>
                <a href="tel:023-67665596">023-67665596</a><br/>
                <a href="tel:18580875987">18580875987</a>(张先生)<br/>
                <div class="btn1" @click="modelShow=false">确定</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "footers",
        data() {
            return {
                modelShow:false
            }
        },
        methods: {
            open() {
                this.modelShow = true;
            },
        }
    }
</script>

<style scoped>
    .footer-wap{
        font-size: 0.24rem;
        text-align: center;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #363A44;
        background: #EDF1F4;
    }

    .footer-wap span{
        display: block;
        margin-top: 0.3rem;
    }
    .footer-wap .phone{
        width: 7.12rem;
        height: .88rem;
        font-size: 0.30rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        background: #0079FF;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 0.10rem;
        margin: 0 auto;
    }
    .footer-wap i{
        font-size: 2rem;
    }

    .footer-botton{
        width: 100%;
        height: 1.08rem;
        background: #0067AC;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 0.4rem;
        color: #ffffff;
    }
    .model-box22{
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 999;
    }
    .model-box22 .model-bg{
        background-color: #00000070;
        position: absolute;
        width: 100%;
        height: 100%;
        cursor: pointer;
    }

    .model-box22 .model-content{
        width: 300px;
        height: 200px;
        border-radius: 10px;
        background-color: #ffffff;
        position: relative;
        z-index: 99;
        line-height: 1.6;
        padding-top: 40px;
        box-sizing: border-box;
        font-size: 16px;
    }
    .model-box22 .model-content .btn1{
        width: 80px;
        height: 40px;
        background-color: #0079ff;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        color: #ffffff;
        border-radius: 6px;
        margin:  20px auto 0;
    }
</style>
